(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('getwellApp')
        .constant('VERSION', "1.6.1")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
